import { createStore } from 'vuex'
import login from "./login"
import user from "./user"
import enums from "./enums"
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    login,
    user,
    enums
  }
})
